module.exports = __webpack_public_path__ + "assets/img/3ba8b75e0b693e6d48f2b26b75860cf5.webp";